export default {
  brand_name: 'USFans Spreadsheet',
  nav_spreadsheet: 'Arkusz',
  nav_guides: 'Poradniki',
  nav_reviews: 'Opinie',
  nav_shipping: 'Wysyłka',
  nav_safety: 'Bezpieczeństwo',
  nav_faq: 'FAQ',
  nav_mainWebsite: 'Strona główna',
  nav_home: 'Strona główna',
  nav_shoppingGuide: 'Przewodnik zakupowy',
  nav_browseCategories: 'Przeglądaj kategorie',
  read_more: 'Czytaj więcej',
};